import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "m-3 p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueInputText = _resolveComponent("PrimeVueInputText")!
  const _component_PrimeVueMultiSelect = _resolveComponent("PrimeVueMultiSelect")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_PrimeVueMultiSelect, {
      "model-value": _ctx.modelValue,
      loading: _ctx.loading,
      disabled: _ctx.disabled,
      options: _ctx.sortedOptions,
      "option-value": "id",
      "option-label": _ctx.optionLabel,
      "data-key": "id",
      display: "chip",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_PrimeVueInputText, {
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            placeholder: "Search",
            disabled: _ctx.loading
          }, null, 8, ["modelValue", "disabled"]), [
            [_directive_focus]
          ])
        ])
      ]),
      chip: _withCtx(({ value }) => [
        _createTextVNode(_toDisplayString(_ctx.optionsMap[value] || value), 1)
      ]),
      _: 1
    }, 8, ["model-value", "loading", "disabled", "options", "option-label"])
  ]))
}